<template>
  <button v-if="mode === 'auto'" class="rp-buy-button rp-button"
    v-on:click="addToCart"
    v-bind:style="{
      backgroundColor: openCart === false ? color.secondarySub:color.secondaryMain,
      color: openCart === false ? color.secondaryMain:color.secondarySub,
      borderColor: color.secondaryMain,
      fontFamily: globalFont
    }">
    <span v-if="openCart === false" class="rp-icon">
      <i class="fa fa-plus"></i>
    </span>
     <span v-else class="rp-icon">
      <i class="fa fa-shopping-cart"></i>
    </span>
    <span>{{ rpLabel }}</span>
  </button>
  <button v-else class="rp-buy-button rp-button-custom"
    v-on:click="addToCart"
    v-bind:style="{
      backgroundColor: color.secondaryMain,
      color: color.secondarySub,
      borderColor: color.secondaryMain,
      fontFamily: globalFont
    }">
    <span v-if="mode === 'auto'" class="rp-icon">
      <i class="fa fa-shopping-cart"></i>
    </span>
    <span>{{ rpLabel }}</span>
  </button>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'AddToCartButton',
  props: {
    mode: {
      type: String,
      default: 'auto'
    },
    productSku: {
      type: [String, Number],
      default: null
    },
    productQuantity: {
      type: Number,
      default: 1
    },
    productVariantSelected: {
      type: Number,
      default: 1
    },
    openCart: {
      type: Boolean,
      default: false
    },
    rpLabel: {
      type: String,
      default: 'Add to Cart'
    },
    rpLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          alertPleaseSelectVariants: 'Please select a product variants',
          expiration_date_cannot_be_in_the_past: 'Expiration date cannot be in the past'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          alertPleaseSelectVariants: 'กรุณาเลือกตัวเลือกย่อยของสินค้า',
          expiration_date_cannot_be_in_the_past: 'Expiration date cannot be in the past'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          alertPleaseSelectVariants: 'Vui lòng chọn đặc điểm sản phẩm',
          expiration_date_cannot_be_in_the_past: 'Ngày hết hạn không thể trong quá khứ'
        }
      }
    },
    color () {
      return Cart.getColor()
    },
    globalFont () {
      return Cart.getGlobalFont()
    },
    totalProductQuantity () {
      return Cart.totalProductQuantity
    },
  },
  methods: {
    addToCart () {
      if (this.productVariantSelected === 1) {
        if (this.rpLink != '') {
          if (this.rpLink == 'disable') {
            // Do Nothing...
          } else {
            document.location = this.rpLink
          }
        } else { 
          Cart.hideCartPulse()
          if (this.totalProductQuantity === 0) {
            Cart.addToCart(response => {
              if (response) {
                Cart.$emit('openCart', this.openCart)
              } else {
                Cart.setIsOutOfStock(true)
              }
            }, this.productSku, this.productQuantity)
            Cart.showCartPulse()
            let timeoutId = setTimeout(() => {
              Cart.hideCartPulse()
            }, 1000)
            Cart.setCartPulseTimeout(timeoutId)
          } else {
            Cart.showCartPulse()
            let timeoutId = setTimeout(() => {
              Cart.hideCartPulse()
              Cart.addToCart(response => {
                if (response) {
                  Cart.$emit('openCart', this.openCart)
                } else {
                  Cart.setIsOutOfStock(true)
                }
              }, this.productSku, this.productQuantity)
            }, 1000)
            Cart.setCartPulseTimeout(timeoutId)
          }
        }
      } else {
        alert(this.t.alertPleaseSelectVariants)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .rp-buy-button {
    min-width: 150px;
  }
</style>


// WEBPACK FOOTER //
// src/components/AddToCartButton.vue